<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <etapa-detalhar
                    :projeto="projeto"
                    :etapa="etapa"
                ></etapa-detalhar>
                <div class="mb-4">
                    <h4 class="heading-1 mt-3">
                        <span>RATEIO</span>
                    </h4>
                </div>
                <app-erros-box
                    :erros="erros"
                    v-if="erros.length > 0"
                ></app-erros-box>
                <b-row class="mb-2">
                    <b-col>
                        <app-btn-voltar v-if="operacao == 'D'"></app-btn-voltar>
                        <div
                            class="d-inline text-danger ml-2"
                            v-if="mostrarMsgImpedimentoSgtec"
                        >
                            <span
                                >Não é possível atualizar o rateio no SGTEC:
                                <strong>{{ mensagemSgtec }}</strong></span
                            >
                        </div>
                        <b-button
                            variant="primary"
                            class="ml-2"
                            @click="operacao = 'I'"
                            v-if="mostrarBtnAtualizarRateio"
                            ><i class="fa fa-edit"></i> Atualizar
                            Rateio</b-button
                        >
                        <btn-inserir-dotacao
                            class="d-inline mr-2"
                            v-if="operacao != 'D' && rateioTabela.length == 0"
                            :valorTotal="valorASerRateado"
                            :valorDisponivel="valorDisponivel"
                            @inserirRateio="inserirRateio($event)"
                            :servicos="servicos"
                        ></btn-inserir-dotacao>
                        <b-button
                            variant="primary"
                            v-if="operacao != 'D'"
                            :disabled="valorDisponivel > 0 || !rateioAlterado"
                            @click.stop="confirmarSalvar()"
                            ><i class="fa fa-floppy-o"></i> Salvar</b-button
                        >
                        <b-button
                            class="ml-2"
                            variant="danger"
                            v-if="operacao != 'D'"
                            @click="cancelar()"
                            ><i class="fa fa-times-circle-o"></i>
                            Cancelar</b-button
                        >
                    </b-col>
                </b-row>
                <b-row v-if="operacao != 'D'">
                    <b-col>
                        <app-box titulo="Total a ser rateado">{{
                            valorASerRateado | currency
                        }}</app-box>
                    </b-col>
                    <b-col>
                        <app-box
                            titulo="Total rateado"
                            :corBox="corBox"
                            :corTexto="corTexto"
                            >{{ valorRateado | currency }} |
                            {{
                                percentualRateado
                                    | currency({
                                        symbol: '%',
                                        thousandsSeparator: '.',
                                        fractionCount: 2,
                                        fractionSeparator: ',',
                                        symbolPosition: 'back',
                                        symbolSpacing: false
                                    })
                            }}</app-box
                        >
                    </b-col>
                    <b-col>
                        <app-box
                            titulo="Total disponível para ratear"
                            :corBox="corBox"
                            :corTexto="corTexto"
                            >{{ valorDisponivel | currency }}</app-box
                        >
                    </b-col>
                </b-row>
                <rateio-tabela
                    :rateio="rateioTabela"
                    :temAcoes="etapa && (operacao != 'D' || etapa.rateioManual)"
                    :valorASerRateado="valorASerRateado"
                    :valorDisponivel="valorDisponivel"
                    :operacao="operacao"
                    @atualizarRateio="atualizarRateio($event)"
                    @excluirRateio="excluirRateio($event)"
                >
                    <template slot="botoes"> </template>
                </rateio-tabela>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import RateioTabela from './RateioTabela'
import BtnInserirDotacao from './BtnInserirDotacao'
import EtapaDetalhar from '../etapas/EtapaDetalhar'

export default {
    components: {
        RateioTabela,
        BtnInserirDotacao,
        EtapaDetalhar
    },

    props: {
        servicos: {
            type: Object,
            default: () => {}
        },

        permiteAtualizarRateio: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            erros: [],
            projeto: null,
            etapa: null,
            rateio: [],
            operacao: 'D',
            rateioTabela: [],
            rateioAlterado: false,
            permiteAtualizarRateio2: false,
            permiteAtualizarRateioSgtec: false,
            mensagemSgtec: null
        }
    },

    methods: {
        obterEtapaRateio() {
            this.$store.dispatch('addRequest')
            this.servicos
                .obterEtapaRateio(this.$route.params.etapaId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.projeto = response.data.projeto
                            this.etapa = response.data.etapa
                            this.rateio = response.data.rateio
                            this.rateioTabela = JSON.parse(
                                JSON.stringify(this.rateio)
                            )
                            this.permiteAtualizarRateio2 =
                                response.data.permiteAtualizarRateio
                            this.permiteAtualizarRateioSgtec =
                                response.data.permiteAtualizarRateioSgtec
                            this.mensagemSgtec = response.data.mensagemSgtec
                        } else {
                            this.$toast.error(
                                'Erro ao obter etapa!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        cancelar() {
            this.operacao = 'D'
            this.resetarRateios()
        },

        resetarRateios() {
            if (this.rateio) {
                this.rateioTabela = JSON.parse(JSON.stringify(this.rateio))
            }
        },

        inserirRateio(rateio) {
            if (
                this.rateioTabela.filter((r) => {
                    return (
                        r.codUnidade == rateio.codUnidade &&
                        r.codProjeto == rateio.codProjeto &&
                        r.codAcao == rateio.codAcao
                    )
                }).length > 0
            ) {
                this.erroNaInclusaoDotacao()
            } else {
                rateio.status = 1
                rateio.dataAtualizacao = new Date()
                this.rateioTabela.push(rateio)
                this.rateioAlterado = true
            }
        },

        erroNaInclusaoDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Já existe dotação com a unidade/projeto/ação informados`,
                icon: 'error'
            })
        },

        atualizarRateio(rateio) {
            for (let index = 0; index < this.rateioTabela.length; index++) {
                const rateioAtual = this.rateioTabela[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateioTabela[index].valor = rateio.valor
                    this.rateioTabela[index].percentual = rateio.percentual
                    this.rateioTabela[index].justificativa =
                        rateio.justificativa
                    this.rateioTabela[index].dataAtualizacao = new Date()
                    break
                }
            }
        },

        excluirRateio(rateio) {
            for (let index = 0; index < this.rateioTabela.length; index++) {
                const rateioAtual = this.rateioTabela[index]
                if (
                    rateioAtual.codUnidade == rateio.codUnidade &&
                    rateioAtual.codProjeto == rateio.codProjeto &&
                    rateioAtual.codAcao == rateio.codAcao
                ) {
                    this.rateioTabela.splice(index, 1)
                    this.rateioAlterado = true
                    break
                }
            }
        },

        confirmarSalvar() {
            this.$swal({
                title: 'Rateio',
                html: `Confirma as alterações no rateio da etapa?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>Ao confirmar a alteração no rateio, modificações realizadas no SGTEC
                                não serão refletidas no Espaço do Fornecedor</h4>
                            </div>
                        </div>
                     </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvarEtapaRateio()
                }
            })
        },

        salvarEtapaRateio() {
            this.$store.dispatch('addRequest')
            let rateioAtualizadoDto = {
                etapaId: this.$route.params.etapaId,
                rateio: this.rateioTabela
            }
            this.servicos
                .salvarEtapaRateio(rateioAtualizadoDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Rateio atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.obterEtapaRateio()
                            this.operacao = 'D'
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        valorASerRateado() {
            if (this.etapa) {
                return this.etapa.valorTotal
            }
            return 0
        },

        valorRateado() {
            return Number.parseFloat(
                this.rateioTabela
                    .map((item) => {
                        return item.valor
                    })
                    .reduce((a, b) => a + b, 0)
                    .toFixed(2)
            )
        },

        valorDisponivel() {
            return Number.parseFloat(
                (this.valorASerRateado - this.valorRateado).toFixed(2)
            )
        },

        percentualRateado() {
            return (this.valorRateado / this.valorASerRateado) * 100
        },

        corTexto() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        corBox() {
            return this.percentualRateado < 100 ? 'danger' : 'primary'
        },

        mostrarBtnAtualizarRateio() {
            if (this.etapa) {
                return (
                    this.operacao == 'D' &&
                    this.permiteAtualizarRateio &&
                    this.permiteAtualizarRateio2
                )
            }
            return false
        },

        mostrarMsgImpedimentoSgtec() {
            if (this.etapa) {
                return (
                    !this.permiteAtualizarRateioSgtec &&
                    this.etapa.status !== 'CANCELADA' &&
                    this.etapa.status !== 'CANCELADO'
                )
            }
            return false
        }
    },

    watch: {},

    mounted() {
        this.obterEtapaRateio()
    }
}
</script>
